
export function setCacheItem(name, value) {
    const jsonVal = JSON.stringify(value);
    localStorage.setItem(name, jsonVal);
}

export function getCacheItem(name) {

    const val = localStorage.getItem(name);

    if (val) {
        return JSON.parse(val);
    }
}
    
export function removeCacheItem(name) {
    localStorage.removeItem(name);
}